export default class ApplicationCampaignInfoDomainService {
    static fromJSON(json) {
        return Object.assign({}, json);
    }
    static getInfoTextFields(info) {
        const fields = [];
        if (info.applicationStatuses.length) {
            fields.push({
                label: "Status(es)",
                value: info.applicationStatuses
                    .map(({ applicationStatusName }) => applicationStatusName)
                    .join(", "),
            });
        }
        if (info.academicCalendars.length) {
            fields.push({
                label: "Term(s)",
                value: info.academicCalendars.map(({ name }) => name).join(", "),
            });
        }
        if (info.programs.length) {
            fields.push({
                label: "Program(s)",
                value: info.programs.map(({ name }) => name).join(", "),
            });
        }
        if (info.overrideTaskTitle) {
            fields.push({
                label: "Task  Title",
                value: info.overrideTaskTitle,
            });
        }
        if (info.overrideTaskDescription) {
            fields.push({
                label: "Task Description",
                value: info.overrideTaskDescription,
            });
        }
        return fields;
    }
}
